import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const getDefaultState = () => ({
  user: '',
  account: [],
  advertisers: [],
  env: process.env.VUE_APP_ENVIRONMENT,
});
const state = getDefaultState();

export default new Vuex.Store({
  plugins: [
    createPersistedState(),
  ],
  state,
  getters: {
    hasUser: state => !!state.user,
  },
  mutations: {
    logout(state) {
      Object.assign(state, getDefaultState());
    },
    authenticate(state, payload) {
      state.user = payload.user;
      state.account = payload.account;
      payload.advertisers = payload.advertisers.map((advertiser) => {
        advertiser.campaigns = advertiser.campaigns.map((campaign) => {
          campaign.clicked = false;
          return campaign;
        });
        return advertiser;
      });
      state.advertisers = payload.advertisers;
    },
  },
  actions: {

  },
});
